// src/components/SchemaTree.tsx
import React, { useEffect, useState } from 'react';
import Tree from 'rc-tree';
import 'rc-tree/assets/index.css';
import '../styles/SchemaTree.css';
import { SchemaNode } from '../App';
import { TailSpin } from 'react-loader-spinner';
import '../styles/SchemaEditor.css';

interface RcTreeData {
  key: string;
  title: string;
  children?: RcTreeData[];
  schemaId?: string;
}

interface SchemaTreeProps {
  onSelect: (node: SchemaNode | null) => void;
}

const SchemaTree: React.FC<SchemaTreeProps> = ({ onSelect }) => {
  const [treeData, setTreeData] = useState<RcTreeData[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [expandedKeys, setExpandedKeys] = useState<string[]>([]);

  useEffect(() => {
    setIsLoading(true);
    fetch('https://api.psanalytics.co.uk/editor/getSchemas')
      .then((res) => {
        if (!res.ok) {
          throw new Error('Network response was not ok');
        }
        return res.json();
      })
      .then((data) => {
        const modelsNode: RcTreeData = {
          key: 'models',
          title: 'Models',
          children: data.models.map((item: any, index: number) => ({
            key: item.$id ? item.$id : (item.schemaId ? item.schemaId : `models-${index}-${item.title}`),
            title: item.title,
            schemaId: item.$id || item.schemaId,
          })),
        };
        const cvsNode: RcTreeData = {
          key: 'cvs',
          title: 'CVs',
          children: data.cvs.map((item: any, index: number) => ({
            key: item.$id ? item.$id : (item.schemaId ? item.schemaId : `cvs-${index}-${item.title}`),
            title: item.title,
            schemaId: item.$id || item.schemaId,
          })),
        };

        setTreeData([modelsNode, cvsNode]);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching schema data:', error);
        setIsLoading(false);
      });
  }, []);

  const onExpand = (keys: React.Key[], info: any) => {
    setExpandedKeys(keys.map(String));
  };

  const onSelectHandler = (selectedKeys: React.Key[], info: any) => {
    if (info.selected && info.node && info.node.schemaId) {
      onSelect({ title: info.node.title, schemaId: info.node.schemaId });
    } else {
      onSelect(null);
    }
  };

  return (
    <div className="schema-tree">
      {isLoading ? (
        <div className="spinner-container">
          <TailSpin color="#007bff" height={50} width={50} />
          <p>Loading schemas...</p>
        </div>
      ) : (
        <Tree
          treeData={treeData}
          expandedKeys={expandedKeys}
          onExpand={onExpand}
          defaultExpandAll={false}
          onSelect={onSelectHandler}
        />
      )}
    </div>
  );
};

export default SchemaTree;
